  
<template>
    <div class="know">
        <!-- <img class="img" :src="$route.query.pic" alt=""> -->
        <v-list class="list"></v-list>
    </div>
</template>

<script>
export default {
   data(){
    return{

    }
   },
   created(){

   },
   methods:{
      
   },
   
beforeRouteEnter (to, from, next) {
     // 详情页路由 设置isBack为 true 还是 false
      to.meta.isBack = from.path === '/detail'
      next()
 },
}
</script>

<style lang="less" scped>
.know{
    background: #F5F5F5;
    width: 100%;
   .img{
        width: 100%;
        height: 2.1rem;
        position: fixed;
        left: 0;
        top: 0;
    }
    .list{
        // min-height: calc(100vh - 0.2rem);
    }  
}
</style>


// WEBPACK FOOTER //
// src/modules/know.vue